import { caretDownOutline, caretUpOutline } from 'ionicons/icons';
import { FundListSortColumn, SortDirection } from '@/types/fund.types';
import { Icon } from './Icon';

interface SortHeaderProps {
  label: string;
  column: FundListSortColumn;
  activeColumn: FundListSortColumn;
  direction: SortDirection;
  onToggle: (column: FundListSortColumn) => void;
  className?: string;
}

/**
 * Replaces the repeated ion-icon + ion-label sort header blocks on the home
 * page. The whole header is the button now, rather than only the caret, which
 * gives a much larger target on touch.
 */
export function SortHeader({
  label,
  column,
  activeColumn,
  direction,
  onToggle,
  className = '',
}: SortHeaderProps) {
  const isActive = column === activeColumn;
  const isAscending = direction === SortDirection.ASCENDING;

  return (
    <button
      type="button"
      onClick={() => onToggle(column)}
      title={`Sort by ${label.toLowerCase()}`}
      aria-sort={isActive ? (isAscending ? 'ascending' : 'descending') : 'none'}
      className={`inline-flex items-center gap-1 rounded font-semibold text-content hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus ${className}`}
    >
      {/*
        Same logic as the Angular getHeaderIconName: caret down unless this is
        the active column sorted descending. The active column is orange
        (.header-icon-selected).
      */}
      <Icon
        icon={isActive && !isAscending ? caretUpOutline : caretDownOutline}
        className={`size-4 ${isActive ? 'text-primary' : 'text-muted'}`}
      />
      <span>{label}</span>
    </button>
  );
}

